import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/:id?',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
